// A dialog that shows a PDF (a contract, an invoice, a report): centred on a computer, the whole screen
// on a phone (the viewer takes what the header leaves). → { variant, styleOverrides, height } for the
// Modal and its PDFViewer (`compact`: below a computer's width — a phone, a small tablet — the toolbar has no room for all); `desktopHeight`: the viewer's height on a computer, `reserve`: what sits
// above the viewer on a phone besides the header (a line of text).
import useIsMobile from "aldoo-ra/Hooks/use-is-mobile"

const DESKTOP = { container: "w-full max-w-[1000px] max-h-full md:max-h-[calc(100vh-2rem)] bg-admin_paper md:rounded-lg border border-admin_bordered shadow-lg overflow-hidden" }

export default function usePdfModal({ desktopHeight = "75vh", reserve = 0 } = {}) {
  const mobile = useIsMobile()
  const compact = useIsMobile("(max-width: 1023px)")
  if (!mobile) return { compact, variant: "admin", styleOverrides: DESKTOP, height: desktopHeight }
  return { compact, variant: "admin_fullscreen", styleOverrides: { content: "px-0 pb-0 h-full min-h-0" }, height: `calc(100dvh - ${64 + reserve}px)` }
}
